import { useEffect, useState } from "react";
import { UseComboModelo } from "../../../../../hooks/auxiliar/combo/UseComboModelo";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UseComboOperador } from "../../../reportes/historicoEstadoEquipo/panelHistoricoEstadoFiltro/UseComboOperador";
import { codigosRespuesta, IResponseApiFluent } from "../../../../../Interfaces/base/IResponse";
import { IEquipoModeloOperadorCommand } from "../../../../../Interfaces/auxiliar/IOperador";
import { EquipoModeloOperadorService } from "../../../../../services/auxiliar/EquipoModeloOperadorService";
import { IComboBoxOption } from "@fluentui/react";

export const UsePanelNuevoEquipoModeloOperador=(props:IOpenPanel)=>{
    const [disableForm, setDisableForm] = useState<boolean>(true);
        const [status, setStatus] = useState<codigosRespuesta>(0);
        const [mensaje, setMensaje] = useState<string>("");
        const [loading,setLoading]=useState<boolean>(false)
        const [request,setRequest]=useState<IEquipoModeloOperadorCommand>({equipoModeloId:"",operadorId:""})
        const reset=()=>{
            setMensaje("")
            setRequest({equipoModeloId:"",operadorId:""})
            setStatus(0)
            props.onDismiss()
        }
        const required: (keyof IEquipoModeloOperadorCommand)[] = [
            "equipoModeloId","operadorId"
        ];
        const changeModeloiD=(option: IComboBoxOption)=>{
            setRequest({...request,equipoModeloId:option.key.toString()})
        }
        const changeOperadoriD=(option: IComboBoxOption)=>{
            setRequest({...request,operadorId:option.key.toString()})
        }
         useEffect(()=>{
                    const check = required.every((field) => {
                        const value = request[field];
                        return value !== null && value !== undefined && value !== "";
                      });
                    setDisableForm(!check)
                },[request])
        const CrearRelacion=()=>{
            setLoading(true)
            EquipoModeloOperadorService.Crear(request).then((res)=>{
                if(res.status==200){
                  setMensaje(res.data.mensaje)
                  setStatus(200)
                  setTimeout(()=>{
                    props.reload?.();
                    reset()
                },
                3000)
                }else{
                    setStatus(500)
                    setMensaje("Error")
                }
                setLoading(false)
            }).catch((e)=>{
                if (
                                e.response?.data &&
                                'type' in e.response.data &&
                                'title' in e.response.data &&
                                'status' in e.response.data &&
                                'instance' in e.response.data &&
                                'errors' in e.response.data
                              ) {
                                const errorResponse = e.response.data as IResponseApiFluent;
                                const mensajeError = errorResponse.errors.join('\n');
                                setMensaje(mensajeError);
                              } else {
                                console.log('Error detallado:', e);
                                setMensaje("Error Inesperado");
                              }
                              setStatus(500);
                              setLoading(false)
            })
        }
        return {reset,status,mensaje,disableForm,loading,request,setRequest,CrearRelacion,
            changeModeloiD,changeOperadoriD
        }

}